import * as Utils from "./utils";
import { ValidationBuilder } from "./validation-builder";
import { ValidationBuilderWithIf } from "./validation-builder";
export class PropertyBuilder {
    constructor(builder, propertyName) {
        this.propertyName = propertyName;
        this.builder = builder;
    }
    if(condition) {
        this._lastRule = undefined;
        if (this.builder instanceof ValidationBuilder)
            return this.builder.if(condition);
        else
            return this.builder;
    }
    endIf() {
        if (this.builder instanceof ValidationBuilderWithIf) {
            return this.builder.endIf();
        }
        return this.builder;
    }
    ensure(property) {
        this._lastRule = undefined;
        return this.builder.ensure(property);
    }
    ensureSelf() {
        this._lastRule = undefined;
        return this.builder.ensureSelf();
    }
    setObjectRules(rule) {
        const objectRule = { type: "object", rule };
        this._objectRule = objectRule;
        this._lastRule = objectRule;
        return this;
    }
    setArrayRules(rule) {
        const arrayRule = { type: "object", rule };
        this._arrayRule = arrayRule;
        this._lastRule = arrayRule;
        return this;
    }
    withMessage(message) {
        const lastRule = this._lastRule;
        if (!lastRule)
            return this;
        if (lastRule.type === "primitive") {
            lastRule.message = message;
        }
        else {
            console.warn("message can't be defined for 'Object' or 'Array' Validations.");
        }
        return this;
    }
    when(rule) {
        const lastRule = this._lastRule;
        if (lastRule) {
            lastRule.condition = rule;
        }
        return this;
    }
    #satisfies = (predicate) => {
        const rule = { type: "primitive", predicate: predicate };
        this._lastRule = rule;
        if (!this._prmitiveRules)
            this._prmitiveRules = [];
        this._prmitiveRules.push(rule);
        return this;
    };
    #satisfiesWithMessage = (predicate) => {
        const predicateFn = (value, obj) => predicate(value, obj)[0];
        const messageFn = (value, obj) => predicate(value, obj)[1];
        const rule = { type: "primitive", predicate: predicateFn };
        this._lastRule = rule;
        if (!this._prmitiveRules)
            this._prmitiveRules = [];
        this._prmitiveRules.push(rule);
        this._lastRule.message = messageFn;
        return this;
    };
    satisfiesWithMessage(predicate) {
        return this.#satisfiesWithMessage(predicate);
    }
    satisfies(predicate) {
        return this.#satisfies(predicate);
    }
    required(treatZeroAsNull) {
        this.#satisfies((value) => Utils.isPresent(value, treatZeroAsNull));
        this.withMessage(`Field ${this.propertyName} is required`);
        return this;
    }
    email() {
        this.#satisfies((value) => Utils.isEmail(value));
        this.withMessage(`${this.propertyName} must be valid email`);
        return this;
    }
    rangeLength(min, max) {
        this.#satisfies((value) => {
            if (value === undefined || value === null)
                return false;
            if (value.toString().length < min)
                return false;
            if (value.toString().length > max)
                return false;
            return true;
        });
        if (min === max)
            this.withMessage(`${this.propertyName} must be ${min} character long`);
        else
            this.withMessage(`${this.propertyName} must be at least ${length} character long`);
        return this;
    }
    minLength(length) {
        this.#satisfies((value) => {
            if (value === undefined || value === null)
                return false;
            if (value.toString().length < length)
                return false;
            return true;
        });
        this.withMessage(`${this.propertyName} must be at least ${length} character long`);
        return this;
    }
    maxLength(length) {
        this.#satisfies((value) => {
            if (value === undefined || value === null)
                return false;
            if (value.toString().length > length)
                return false;
            return true;
        });
        this.withMessage(`${this.propertyName} must be at less than ${length} character long`);
        return this;
    }
    isLowerCasePresent() {
        this.#satisfies(Utils.isLowerCasePresent);
        this.withMessage(`${this.propertyName} must have at least one lower case character`);
        return this;
    }
    isUpperCasePresent() {
        this.#satisfies(Utils.isUpperCasePresent);
        this.withMessage(`${this.propertyName} must have at least one upper case character`);
        return this;
    }
    isNumericPresent() {
        this.#satisfies(Utils.isNumberPresent);
        this.withMessage(`${this.propertyName} must have at least one number type character`);
        return this;
    }
    isCreditCard() {
        this.#satisfies(Utils.isValidCreditCard);
        return this;
    }
    requiredMMYY() {
        this.#satisfies(Utils.isMMYYPresent);
        return this;
    }
    isMMYY() {
        this.#satisfies(Utils.isMMYYValid);
        return this;
    }
    isHHMM() {
        this.#satisfies(Utils.isHHMMValid);
        return this;
    }
    isNotNull() {
        this.#satisfies(value => value !== null && value !== undefined);
        return this;
    }
    isNull() {
        this.#satisfies(value => value === null || value === undefined);
        return this;
    }
    isStartsWith(startsWith) {
        this.#satisfies(value => Utils.isStartsWith(value, startsWith));
        this.withMessage(`${this.propertyName} must starts with ${startsWith}`);
        return this;
    }
    isEndsWith(endsWith) {
        this.#satisfies(value => Utils.isEndssWith(value, endsWith));
        this.withMessage(`${this.propertyName} must end with ${endsWith}`);
        return this;
    }
    range(min, max) {
        this.#satisfies(value => value >= min && value <= max);
        this.withMessage(`${this.propertyName} must be between ${min} and ${max}`);
        return this;
    }
    isDate() {
        this.#satisfies(value => !!value ? value instanceof Date : true);
        this.withMessage(`${this.propertyName} must be of type Date`);
        return this;
    }
    // then() {
    //     const newRule = new PropertyBuilder(this.builder, this.propertyName);
    //     this.rules.slice(-1)[0].then = newRule;
    //     return newRule;
    // }
    rules() {
        return this.builder.rules();
    }
    build() {
        const validator = this.builder.build();
        return validator;
    }
}
